import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import LazyLoad from "react-lazyload";
import { FaCalendarAlt } from "react-icons/fa";
import { Link } from "react-router-dom";

import * as apiUrl from "../../apiUrl";

function CareerList() {
  const [CareerLists, setCareerLists] = useState([]);

  useEffect(() => {
    const fetchCareerLists = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/careers/job-descriptions`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setCareerLists(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchCareerLists();
  }, []);

  return ( 
      <section className="career-list-sec">
        <Container fluid>
          <Row className="flex-center text-center">
            <Col md={12}>
              <div className="" data-aos="fade-up">
                <h2 className="common-head goldenColor mb-4" data-aos="fade-up">
                  Open Positions
                </h2>
              </div>
            </Col>
          </Row>
        </Container>
        <Container fluid className="careers-grid-container">
          {CareerLists.map((careerlist, index) => (
            <Row
              className="careers-grid-row" 
              key={careerlist.id}
            >
              <Col md={5}>
                <div className="careers-head-div">
                  <h5 className="luxury-font">{careerlist.title}</h5>
                </div>
              </Col>
              <Col md={7} className="padding-zero">
                <div className="career-right-content">
                  {/* <div className="careers-date-div">
                    <p className="career-date">
                      {" "}
                      <FaCalendarAlt /> Job posted on :{" "}
                      {careerlist.posting_date}
                    </p>
                  </div> */}
                  <div className="careers-jobtype-div">
                    <p className="careers-jobtype">
                      Job Type : {careerlist.job_type}
                    </p>
                  </div>
                  <div className="careers-button-div">
                    <Link
                      to={`/careers/${careerlist.slug}`}
                      className="marquis-roundededge-button"
                    >
                      Read More
                    </Link>
                  </div>
                </div>
              </Col>
            </Row>
          ))}
        </Container>
      </section> 
  );
}

export default CareerList;
